import { usePetitionCommentPageData } from '#src/app/pages/petitionComment/pageContext';

type Result = ModelHookResult<{
	showUnderReviewBanner: boolean;
}>;

export function usePageBanner(): Result {
	const {
		data: {
			petition: { status },
		},
	} = usePetitionCommentPageData();

	return {
		data: {
			showUnderReviewBanner: status === 'UNDER_REVIEW',
		},
	};
}
